<div id="tv-select">
  <div class="select-trigger"
       [attr.dpad]="dpad"
       [style.--scale-dpad]="scaledpad"
       [attr.x-dpad]="xdpad"
       [attr.y-dpad]="ydpad"
       [attr.tab-dpad]="tabdpad"
       [attr.x-tab-dpad]="xtabdpad"
       [attr.y-tab-dpad]="ytabdpad"
       [id]="id"
       [class.select-disable]="disabled"
       (click)="openDialog()"
       tabindex="0">
    <span class="summary">{{ selectedItemName }}</span>
    <i class="sl-icon pi pi-angle-down"></i>
  </div>

  <div class="tv-overlay" [class.show]="dialogVisible"
       (click)="false && onCancel()"></div>

  <div class="tv-modal-shell"  #dialogSingle *ngIf="dialogVisible" [class.show]="true">
    <div class="tv-modal-panel">
      <ul class="tv-list">
        <li *ngFor="let item of viewOptions; let idx = index"
          class="option-item"
          [attr.scaledpad]="1"
          [attr.dpad]="currentZone"
          [attr.x-dpad]="0"
          [attr.y-dpad]="idx"
          (click)="onSelectValue(item.value)"
        >
          <caremoni-radio-button [isChecked]="selectedValue?.toString() === item.value?.toString()" ></caremoni-radio-button>
          <span class="label-select">{{ item.name || '' }}</span>
        </li>
        <div class="no-data-txt" *ngIf="viewOptions.length === 0">{{COMMON_TEXT.NO_DATA}}</div>
      </ul>

    </div>
  </div>
</div>